import { AxiosResponse } from 'axios';
import { AppIsSafeToEditUpdateRequest } from '../../Classes/ResponseModels/ApplicationManagement/AppIsSafeToEditUpdateRequest';
import AxiosInstance from '../../services/axios/axios';
import AppManagementModel, {
	AppComponent,
	AppData,
	AppExport,
	ComponentType,
	Extension,
	NotificationEvent,
	AppExtension,
	ComponentDependency,
} from '../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import NewAppRequest from 'Classes/ResponseModels/ApplicationManagement/NewAppRequest';
import { convertIntBoolFlags } from './_utils';
import ApprovalsRequest from '../../Classes/ResponseModels/ApplicationManagement/ApprovalRequest';
import ExtensionTypeRequest from '../../Classes/ResponseModels/ApplicationManagement/ExtensionTypeRequest';
import ComponentUpdateRequest from 'Classes/ResponseModels/ApplicationManagement/ComponentUpdateRequest';
import { WORK_QUE_TYPES } from './_constants';
import AppDataUpdateRequest from 'Classes/ResponseModels/ApplicationManagement/AppDataUpdateRequest';
import ComponentDependencyRequest from 'Classes/ResponseModels/ApplicationManagement/ComponentDependencyRequest';
import AppManagementRequest from 'Classes/ResponseModels/ApplicationManagement/AppManagementRequest';
import { APPROVAL_WORKFLOW_TYPES } from './actions/UpdateApprovals/_constants';

//app - AppModel (Classes/ResponseModels/Apps.js)
//isSafeToEdit - bool
export const updateAppAuxIsSafeToEdit = async (
	app,
	isSafeToEdit,
	currentUser
) => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/AppAux/update',
			new AppIsSafeToEditUpdateRequest(
				app,
				isSafeToEdit,
				currentUser.Name
			)
		);

		return response;
	} catch (ex) {
		console.error(
			'error occured while updating T_Application_AUX.F_isSafeToEdit' + ex
		);
		return {
			data: [],
			error: 'Unable to updated isSafeToEdit',
		};
	}
};

export const CreateIMSApp = async (
	request //AppManagementRequest
) => {
	request.App = convertIntBoolFlags(request.App);

	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/New',
			request
		);

		return new AppManagementModel(response.data);
	} catch (ex) {
		console.error('error occured attempting to create new app' + ex);
		return {
			data: [],
			error: 'error occured attempting to create new app',
		};
	}
};

export const GetApplicationManagementIndex = async () => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAll`
		);
		//convert response to AppManagementModel[]
		let apps = response?.data?.map(app => {
			return new AppManagementModel(app);
		});

		return apps;
	} catch (ex) {
		console.error('Unable to fetch Applications info: ' + ex);
		return {
			data: {},
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const GetApplicationManagementByID = async id => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetByID?appID=${id}`
		);
		//convert response to AppManagementModel[]
		let app = new AppManagementModel(response.data);

		return app;
	} catch (ex) {
		console.error('Unable to fetch Applications info: ' + ex);
		return {
			data: {},
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

//App Actions---------------------------------------------------
////update app tables (T_Application_Master, T_UPMC_Application, T_Application_AUX)
//param request : AppManagementRequest
//returns AppManagementModel instance
export const UpdateAppTables = async request => {
	request.App = convertIntBoolFlags(request.App);

	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/UpdateAppTables',
			request
		);

		return new AppManagementModel(response.data);
	} catch (ex) {
		console.error('error occured attempting to create new app' + ex);
		return {
			data: [],
			error: 'error occured attempting to create new app',
		};
	}
};

//Email Notifications:
export const GetAppNotifications = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppNotifications?appID=${appID}`
		);
		return new AppManagementModel(response.data);
	} catch (ex) {
		console.error(
			`error occured attempting to retrieve notifications for appID ${appID} ` +
				ex
		);
		return {
			data: [],
			error: `error occured attempting to get notifications for appID ${appID}`,
		};
	}
};

export const CreateAppNotification = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/CreateEvent',
			request
		);
		return new AppManagementModel(response.data);
	} catch (ex) {
		console.error(
			`error occured attempting to create notification event matrix record for app id ${request.appID}, event type ${request.eventTypeID}, action id ${request.actionID}`
		);
	}
};

//request : AppManagementRequest
export const UpdateAppNotification = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/UpdateNotificationRecipients',
			request
		);

		return new AppManagementModel(response.data);
	} catch (ex) {
		console.error(
			'error occured attempting to update recipients for the selected notification event'
		);
	}
};

//appID : int - app master id
//approvalFlowType : string - one of ['SingleLevel','MultiLevel']
export const CheckApprovalWorkFlowType = async (appID, approvalFlowType) => {
	try {
		//dev helper following refactor, ensure approvalFlowType is included
		if (approvalFlowType === null || approvalFlowType === undefined) {
			console.error(
				'approvalFlowType not provided to CheckApprovalWorkFlowType()'
			);
		}
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/CheckApprovalWorkflowType?appID=${appID}&approvalWorkFlowType=${approvalFlowType}`
		);
		return response.data;
	} catch (ex) {
		console.error(
			`error occured attempting to determine Approval workflow type for app ID ${appID}`
		);
	}
};

//request : ApprovalRequest
export const CreateApprovalFlow = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/CreateApprovalFlow',
			request
		);
		return response.data;
	} catch (ex) {
		console.error(`error occured attempting to create approval workflow`);
	}
};

//appID: int (application master ID)
//approvalType: string (one of: ['SingleLevel','MultiLevel'])
export const GetApprovers = async (appID, approvalType) => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetApprovers?appID=${appID}&approvalType=${approvalType}`
		);
		const data = response.data;
		return new ApprovalsRequest(
			null,
			null,
			null,
			data.Reviewers,
			data.ApplicationExtensions
		);
	} catch (ex) {
		console.error(`error occured attempting to get Approvers`);
	}
};

//request: ApprovalRequest
export const UpdateApprovers = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/UpdateApprovers',
			request
		);

		return new ApprovalsRequest(
			request.App,
			request.CreatedBy,
			request.approvalFlowType,
			response.data.Reviewers,
			response.data.ApplicationExtensions
		);
	} catch (ex) {
		console.error('error occured attempting to update approvers');
	}
};

//App_Extensions----------------------------------------------------------
//request : AppExtensionRequest
export const CreateAppExtension = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/CreateAppExtension',
			request
		);

		return new ApprovalsRequest(
			request.App,
			request.CreatedBy,
			request.approvalFlowType,
			response.data.Reviewers,
			response.data.ApplicationExtensions
		);
	} catch (ex) {
		console.error('error occured attempting to update approvers');
	}
};

// request : AppExtensionRequest
export const UpdateAppExtension = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/UpdateAppExtension',
			request
		);

		return new ApprovalsRequest(
			request.App,
			request.CreatedBy,
			request.approvalFlowType,
			response.data.Reviewers,
			response.data.ApplicationExtensions
		);
	} catch (ex) {
		console.error('error occured attempting to update approvers');
	}
};

//Extensions------------------------------------------------------------
//request : ExtensionTypeRequest
export const CreateExtensionType = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/CreateExtension',
			request
		);

		return new ExtensionTypeRequest(
			response.data.App,
			request.CreatedBy,
			response.data.Extension
		);
	} catch (ex) {
		console.error('error occured attempting to create extension Type');
		throw ex;
	}
};

//request : extensionTypeRequest
export const DeactivateExtensionType = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/DeactivateExtension',
			request
		);

		return new ExtensionTypeRequest(
			response.data.App,
			request.CreatedBy,
			response.data.Extension
		);
	} catch (ex) {
		console.error('error occured attempting to update approvers');
	}
};

export const UpdateExtensionType = async request => {
	try {
		const response = await AxiosInstance.post(
			'api/ApplicationManagement/UpdateExtension',
			request
		);

		return new ExtensionTypeRequest(
			response.data.App,
			request.CreatedBy,
			response.data.Extension
		);
	} catch (ex) {
		console.error('error occured attempting to update approvers');
	}
};

//Components----------------------------------------------------------------
//appID : int (application master id)
export const GetAppComponents = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetComponents?appID=${appID}`
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to retrieve app components');
	}
};

export const GetComponentTypes = async () => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetComponentTypes`
		);

		return response.data.map(componentType => {
			return new ComponentType(componentType);
		});
	} catch (ex) {
		console.error(
			'error occured attempting to retrieve app component types'
		);
	}
};

//componentUpdateRequest : ComponentUpdateRequest
export const CreateComponent = async componentUpdateRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/CreateComponent`,
			componentUpdateRequest
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create new component');
	}
};

export const UpdateComponent = async componentUpdateRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/UpdateComponent`,
			componentUpdateRequest
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to Update ');
	}
};

//appDataUpdateRequest : AppDataUpdateRequest
//App Data------------------------------------------------------
/**
 *
 * @param {number} componentID unique identifier of component of interest.
 * @returns {Promise<AppData[]>}
 */
export const GetAppData = async componentID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppDataByComponent`,
			{
				params: {
					componentID: componentID,
				},
			}
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to retrieve app data.');
	}
};

//appDataUpdateRequest : AppDataUpdateRequest
export const CreateAppData = async appDataUpdateRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/AppDataCreate`,
			appDataUpdateRequest
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create App Data ');
	}
};

export const UpdateAppData = async appDataUpdateRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/AppDataUpdate`,
			appDataUpdateRequest
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create App Data ');
	}
};

export const DeactivateAppData = async appDataUpdateRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/DeactivateAppData`,
			appDataUpdateRequest
		);

		return response.data;
	} catch (ex) {
		console.error('error occured attempting to deactivate App Data ');
	}
};

////ComponentDependencies
//componentDependencyRequest : ComponentDependencyRequest
export const CreateComponentDependency = async componentDependencyRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/CreateComponentDependency`,
			componentDependencyRequest
		);
		return response.data;
	} catch (ex) {
		console.error(
			'error occured attempting to create component dependency '
		);
	}
};

export const UpdateComponentDependency = async componentDependencyRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/UpdateComponentDependency`,
			componentDependencyRequest
		);
		return response.data;
	} catch (ex) {
		console.error(
			'error occured attempting to update component dependency '
		);
	}
};

export const DeactivateComponentDependency =
	async componentDependencyRequest => {
		try {
			const response = await AxiosInstance.post(
				`api/ApplicationManagement/DeleteComponentDependency`,
				componentDependencyRequest
			);
			return response.data;
		} catch (ex) {
			console.error(
				'error occured attempting to delete component dependency '
			);
		}
	};

export const getComponentDependenciesByComponent = async componentID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetComponentDependenciesByComponent?componentID=${componentID}`
		);
		return response.data;
	} catch (ex) {
		console.error(
			'error occured attempting to retrieve component dependencies'
		);
	}
};

export const GetAppDependencyPairs = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppDependencyPairs?appID=${appID}`
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};

///work que
export const GetWQSystems = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/misc/getWQSystems?appID=${appID}`
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to get WQ Systems ');
	}
};

export const AddNewWQSystem = async request => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/AddWQSystem`,
			request
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create new WQ System ');
	}
};

export const RemoveWQSystem = async request => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/RemoveWQSystem`,
			request
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create new WQ System ');
	}
};

//#region AD Groups
export const ADGroupSearch = async searchTerm => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/ADGroupsSearch?searchTerm=${searchTerm}`
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to Search AD groups ');
	}
};

export const CloudGroupSearch = async (searchTerm, mailEnabled = null) => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/AzureADGroupSearch?query=${searchTerm}${
				mailEnabled !== null ? `&mailEnabled=${mailEnabled}` : ''
			}`
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to Search Cloud Groups');
	}
};

export const EUGroupSearch = async searchTerm => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/EUADGroupSearch?query=${searchTerm}`
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to Search EU Groups');
	}
};

export const GetAppADGroups = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppADGroups?appID=${appID}`
		);
		return response.data;
	} catch (ex) {
		console.error(
			`error occured attempting to get app AD groups for app ${appID}`
		);
	}
};

export const GetAppCloudGroups = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppCloudGroups?appID=${appID}`
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};

export const GetAppEUGroups = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppEUGroups?appID=${appID}`
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};

export const DeactivateAppADGroup = async AppADGroupRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/deactivateAppADGroupXref`,
			AppADGroupRequest
		);
		return response.data;
	} catch (ex) {
		console.error(
			`error ocurred attempting to deactivate AD group mapping`
		);
	}
};

export const DeactivateAppCloudGroup = async AppCloudGroupRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/DeactivateAppCloudGroupXREF`,
			AppCloudGroupRequest
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};

export const DeactivateAppEUGroup = async AppEUGroupRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/DeactivateAppEUGroupXREF`,
			AppEUGroupRequest
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};

export const CreateAppADGroup = async AppADGroupRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/createAppADGroupXref`,
			AppADGroupRequest
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create AD group mapping');
	}
};

export const CreateAppCloudGroup = async AppCloudGroupRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/CreateAppCloudGroupXREF`,
			AppCloudGroupRequest
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};

export const CreateAppEUGroup = async AppEUGroupRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/CreateAppEUGroupXREF`,
			AppEUGroupRequest
		);
		return response.data;
	} catch (ex) {
		throw ex;
	}
};
//#endregion

/// import, export
/**
 * Asynchronously retrieves exhaustive metadata of application of interest.
 *
 * @param {number} appID unique identifier of application to be exported.
 * @returns {Promise<object>} application metadata.
 */
export const exportApp = async appID => {
	let app = await GetApplicationManagementByID(appID);
	for (let i = 0; i < app?.components?.length; i++) {
		let component = { ...app.components[i] };
		const arrAppData = await GetAppData(component.id);
		component.appData = arrAppData.map(data => new AppData(data));

		const arrCompDeps = await getComponentDependenciesByComponent(
			component.id
		);
		component.componentDependencies = arrCompDeps.map(
			dep => new ComponentDependency(dep)
		);
		app.components[i] = component;
	}
	const approvalsSingle = await GetApprovers(
		appID,
		APPROVAL_WORKFLOW_TYPES.SingleLevel
	);
	const approvalsMulti = await GetApprovers(
		appID,
		APPROVAL_WORKFLOW_TYPES.MultiLevel
	);
	const notifications = await GetAppNotifications(appID);

	return new AppExport(app, approvalsSingle, approvalsMulti, notifications);
};

/**
 * @param {Extension[]} arrExtensions
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<void>}
 */
export const importExtensions = async (
	arrExtensions,
	app,
	requirementID,
	user
) => {
	for (let i = 0; i < arrExtensions?.length; i++) {
		let requestExtension = new ExtensionTypeRequest(
			app,
			user,
			arrExtensions[i],
			requirementID
		);
		requestExtension.extension.appID = app.appMaster.id;

		await CreateExtensionType(requestExtension);
	}
};

/**
 * @param {AppComponent[]} arrComponents
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<AppComponent[]>}
 */
export const importComponents = async (
	arrComponents,
	app,
	requirementID,
	user
) => {
	let arrResponses = [];
	for (let i = 0; i < arrComponents?.length; i++) {
		let objComponent = arrComponents[i];
		let requestComponent = new ComponentUpdateRequest(
			app,
			user,
			objComponent
		);
		requestComponent.component.appID = app.appMaster.id;
		requestComponent.RequirementNumber = requirementID;

		const responseComponent = await CreateComponent(requestComponent);
		let component = new AppComponent(responseComponent.Component);
		component.appData = objComponent.appData;
		component.componentDependencies = objComponent.componentDependencies;

		arrResponses.push(component);
	}
	return arrResponses;
};

/**
 * @param {AppComponent[]} arrComponents
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<AppComponent[]>}
 */
export const importComponentData = async (
	arrComponents,
	app,
	requirementID,
	user
) => {
	let arrResponses = [];
	for (let i = 0; i < arrComponents?.length; i++) {
		let component = arrComponents[i];
		let arrData = [];

		for (let j = 0; j < component?.appData?.length; j++) {
			let requestAppData = new AppDataUpdateRequest(
				app,
				user,
				component.appData[j]
			);
			requestAppData.appData.search = app.appMaster.id.toString();
			requestAppData.appData.componentID = component.id;
			requestAppData.RequirementNumber = requirementID;

			const responseAppData = await CreateAppData(requestAppData);
			arrData.push(new AppData(responseAppData.AppData));
		}
		component.appData = arrData;
		arrResponses.push(component);
	}
	return arrResponses;
};

/**
 * @param {AppComponent[]} arrComponents
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<AppComponent[]>}
 */
export const importComponentDependencies = async (
	arrComponents,
	app,
	requirementID,
	user
) => {
	for (let i = 0; i < arrComponents.length; i++) {
		for (
			let j = 0;
			j < arrComponents[i].componentDependencies?.length;
			j++
		) {
			let objCompDep = arrComponents[i].componentDependencies[j];
			objCompDep.componentID = arrComponents[i]?.id;
			objCompDep.component = arrComponents[i];
			// clear redundant object nesting
			objCompDep.component.componentDependencies = [];
			// force look-up by keyword(s) and not id
			objCompDep.componentDependantID = 0;
			objCompDep.conditionalAppDataID = 0;

			const requestCompDep = new ComponentDependencyRequest(
				app,
				user,
				objCompDep
			);
			requestCompDep.RequirementNumber = requirementID;
			await CreateComponentDependency(requestCompDep);
		}
	}
	return arrComponents;
};

/**
 * @param {NotificationEvent[]} arrNotifications
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<void>}
 */
export const importNotifications = async (
	arrNotifications,
	app,
	requirementID,
	user
) => {
	for (let i = 0; i < arrNotifications?.length; i++) {
		let notification = arrNotifications[i];
		notification.appID = app.appMaster.id;

		await CreateAppNotification({
			...notification,
			user: user?.NetworkID,
			requirementNumber: requirementID,
		});
		await UpdateAppNotification(
			new AppManagementRequest(
				new AppManagementModel({
					id: app.appMaster.id,
					NotificationEvents: [notification],
				}),
				user,
				requirementID
			)
		);
	}
};

/**
 * @param {string} approvers
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<void>}
 */
export const importSingleApproval = async (
	approvers,
	app,
	requirementID,
	user
) => {
	const requestApprovalsSingle = new ApprovalsRequest(
		app,
		user,
		APPROVAL_WORKFLOW_TYPES.SingleLevel,
		approvers,
		[],
		requirementID
	);
	await CreateApprovalFlow(requestApprovalsSingle);
	await UpdateApprovers(requestApprovalsSingle);
};

/**
 * @param {AppExtension[]} arrExtensions
 * @param {AppManagementModel} app
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<void>}
 */
export const importMultiApproval = async (
	arrExtensions,
	app,
	requirementID,
	user
) => {
	const requestApprovalsMulti = new ApprovalsRequest(
		app,
		user,
		APPROVAL_WORKFLOW_TYPES.MultiLevel,
		null,
		arrExtensions,
		requirementID
	);
	await CreateApprovalFlow(requestApprovalsMulti);
	await UpdateApprovers(requestApprovalsMulti);
};

/**
 * @param {AppExport} app
 * @returns {Promise<AxiosResponse<boolean>>}
 */
export const validateImport = async app => {
	return AxiosInstance.post('/api/ApplicationManagement/Validate', app)
		.then(response => response?.data?.payload)
		.catch(ex => {
			throw ex;
		});
};

/**
 * @param {AppExport} objExport
 * @param {string} requirementID
 * @param {object} user
 * @returns {Promise<AppManagementModel>}
 */
export const importApp = async (objExport, requirementID, user) => {
	try {
		let requestApp = new NewAppRequest(objExport.app, user);
		requestApp.RequirementNumber = requirementID;
		requestApp.workQueType = WORK_QUE_TYPES.DEFER_TO_IMPORT;

		if (await validateImport(requestApp)) {
			const app = await CreateIMSApp(requestApp);

			await importExtensions(
				objExport.app?.extensions,
				app,
				requirementID,
				user
			);
			let arrComponents = await importComponents(
				objExport.app?.components,
				app,
				requirementID,
				user
			);
			arrComponents = await importComponentData(
				arrComponents,
				app,
				requirementID,
				user
			);
			await importComponentDependencies(
				arrComponents,
				app,
				requirementID,
				user
			);
			await importNotifications(
				objExport?.notifications?.notificationEvents,
				app,
				requirementID,
				user
			);
			if (objExport.approvals.single?.reviewers) {
				await importSingleApproval(
					objExport.approvals.single.reviewers,
					app,
					requirementID,
					user
				);
			}
			if (objExport.approvals.multi?.applicationExtensions?.length > 0) {
				await importMultiApproval(
					objExport.approvals.multi.applicationExtensions,
					app,
					requirementID,
					user
				);
			}

			return await GetApplicationManagementByID(app.appMaster.id);
		}
	} catch (e) {
		throw e;
	}
};

//service accounts--------------
export const GetAccountTypes = async () => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/misc/getAccountTypes`
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to get account Types');
	}
};

export const GetUserTypes = async () => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/misc/getUserTypes`
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to get user Types');
	}
};

//serviceAccountTypeRequest: ServiceAccountTypeRequest.js
export const DeleteServiceAccountType = async serviceAccountTypeRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/ServiceAccount/delete`,
			serviceAccountTypeRequest
		);
		return response.data;
	} catch (ex) {
		console.error(
			'error occured attempting to delete service account type (TS_APP_Service_Account)'
		);
	}
};

//serviceAccountTypeRequest: ServiceAccountTypeRequest.js
export const AddServiceAccountType = async serviceAccountTypeRequest => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/ServiceAccount/add`,
			serviceAccountTypeRequest
		);
		return response.data;
	} catch (ex) {
		console.error(
			'error occured attempting to add service account type (TS_APP_Service_Account)'
		);
	}
};

//DistributionLists--------------------------------------------------------------------------------------

export const GetAppDistributionLists = async appID => {
	try {
		const response = await AxiosInstance.get(
			`api/ApplicationManagement/GetAppDLs?appID=${appID}`
		);
		return response.data;
	} catch (ex) {
		console.error(
			`error occured attempting to get distribution list configurations for app ${appID}`
		);
	}
};

export const DeactivateAppDistributionList =
	async AppDistributionListRequest => {
		try {
			const response = await AxiosInstance.post(
				`api/ApplicationManagement/deactivateAppDistributionList`,
				AppDistributionListRequest
			);
			return response.data;
		} catch (ex) {
			return {
				error: 'Error occurred atttempting to deactivate App Distribution List configuration',
			};
		}
	};

export const CreateDistributionListConfiguration = async payload => {
	try {
		const response = await AxiosInstance.post(
			`api/ApplicationManagement/CreateDistributionListConfiguration`,
			payload
		);
		return response.data;
	} catch (ex) {
		console.error('error occured attempting to create AD group mapping');
	}
};
